import {
  Plane, ClipboardCheck, KeyRound, Briefcase, Home, Landmark, BookOpen,
  Compass, ShieldCheck, Route, Lock, Scale,
} from "lucide-react";

export const icons = { Plane, ClipboardCheck, KeyRound, Briefcase, Home, Landmark, BookOpen, Compass, ShieldCheck, Route, Lock, Scale };

export const Icon = ({ name, ...p }) => {
  const C = icons[name] || Compass;
  return <C {...p} />;
};
